import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import type { ColumnsType } from "antd/lib/table";
import { Button } from "antd";
import { HourglassOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import api from "../../../services/api";
import { useAuth } from "../../../hooks/auth";
import { IActivity } from "../../../components/ProjectActions/ProposalModal";
import Table from "../../../components/Table";
import { IProject } from "../../Projects";
import ProjectStatus from "../../../enums/ProjectStatus";
import HoursModal from "./HoursModal";
import { IDetailedProject } from "../../Project";

interface IRequirement {
  description: string;
  project: IProject;
  id: string;
}

interface IEstimatorActivitiesProps {
  project?: IDetailedProject;
  updateProject?: (project?: IDetailedProject) => void;
}

const EstimatorActivities: FC<IEstimatorActivitiesProps> = ({
  project,
  updateProject,
}) => {
  const [activities, setActivities] = useState<IActivity[]>([]);
  const [selectedActivity, setSelectActivity] = useState<
    IActivity | undefined
  >();
  const [showEstimateModal, setShowEstimateModal] = useState(false);

  const { user } = useAuth();
  const { t } = useTranslation();

  const params = useMemo(() => {
    if (project)
      return {
        project_id: project.id,
        project_status: [ProjectStatus.Understanding],
      };
    return {
      estimator_id: user.id,
      project_status: [ProjectStatus.Understanding],
    };
  }, [user.id, project]);

  const activitiesEstimate = (act: IActivity[]) =>
    act.filter(activity => !activity?.hours);

  useEffect(() => {
    api
      .get<IActivity[]>("/activities/factory", {
        params,
      })
      .then(response => {
        if (!project) {
          const orderActivitiesByIdentifier = response.data.sort((a, b) =>
            a.identifier.localeCompare(b.identifier),
          );

          setActivities(activitiesEstimate(orderActivitiesByIdentifier));
        } else {
          const allActivities = response.data;

          if (activitiesEstimate.length === allActivities.length) {
            setActivities(activitiesEstimate);
          }
        }
      });
  }, [user.id, project]);

  const handleSelectActivity = useCallback(async (activity: IActivity) => {
    setSelectActivity(activity);
    setShowEstimateModal(true);
  }, []);

  const handleEstimateModalClose = useCallback((activity?: IActivity) => {
    setShowEstimateModal(false);
    setSelectActivity(undefined);
    if (activity) {
      setActivities(oldActivities =>
        activitiesEstimate(
          oldActivities.map(oldActivity =>
            oldActivity.id === activity.id ? activity : oldActivity,
          ),
        ),
      );
    }
  }, []);

  /* const requestUpdateProject = useCallback(async () => {
    try {
      const projectUpdate = await api.patch<IDetailedProject>(
        `/projects/${project?.id}`,
        {
          confirm_estimate: true,
        },
      );
      if (updateProject) {
        updateProject(projectUpdate.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []); */

  const activitiesColumns: ColumnsType<IActivity> = [
    {
      title: "Identificador",
      dataIndex: "project",
      render: (_, record) => record.project?.identifier,
    },
    {
      title: "Projeto",
      dataIndex: "project",
      key: "project",
      render: pjt => pjt.short_description,
    },
    {
      title: "Identificador da atividade",
      dataIndex: "identifier",
    },
    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Estimativa",
      dataIndex: "hours",
      key: "hours",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      fixed: "right",
      render: (_, record) => (
        <Button
          title="Estimar"
          type="link"
          icon={<HourglassOutlined />}
          onClick={() => handleSelectActivity(record)}
        />
      ),
    },
  ];
  return activities.length ? (
    <div style={{ marginBottom: "20px" }}>
      <HoursModal
        visible={showEstimateModal}
        handleClose={handleEstimateModalClose}
        activity={selectedActivity}
      />
      <Table
        title={<>Estimar Atividades</>}
        columns={activitiesColumns}
        data={activities}
        footer={() => (
          <>
            {/* {" "}
            {project && !project?.confirm_estimate && (
              <Button
                type="primary"
                title="Confirmar Estimativa"
                onClick={() => requestUpdateProject()}
              >
                Confirmar Estimativa
              </Button>
            )} */}
          </>
        )}
      />
    </div>
  ) : (
    <></>
  );
};

export default EstimatorActivities;
